import styled from 'styled-components';

// Colori di fallback (blu di default tipico dei layer vettoriali) per
// mostrare comunque le geometrie quando lo stile non è ancora configurato.
export const DEFAULT_FILL = '#3388ff';
export const DEFAULT_STROKE = '#3388ff';

// Allinea la spaziatura verticale a quella dei FormItem di antd.
export const PreviewContainer = styled.div`
  margin-bottom: 24px;
`;
